"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegraEstoque = void 0;
var bson_1 = require("bson");
var RegraEstoque = /** @class */ (function () {
    function RegraEstoque() {
        this._id = new bson_1.ObjectId();
        this.REGRA_ESTOQUE = '';
        this.QTD_INI = '';
        this.QTD_FIM = '';
    }
    return RegraEstoque;
}());
exports.RegraEstoque = RegraEstoque;
//# sourceMappingURL=RegraEstoque.js.map